export enum StepKeys {
  LOGIN = 'login-step',
  PIN_CONFIRMATION = 'pin-confirmation-step',
  FORGOT_PASSWORD_CPF = 'forgot-password-cpf-step',
  FORGOT_PASSWORD = 'forgot-password-step',
}
